import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import classificationControlSetsService, {
  ClassificationControlSet,
  UpdateClassificationControlSetRequest,
} from 'services/http/dataset/classification-control-set'

import { UpdateClassificationControlSetProps } from './types'
import ClassificationControlSetForm from './ClassificationControlSetForm'

const UpdateClassificationControlSet: React.FunctionComponent<UpdateClassificationControlSetProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [classificationControlSet, setClassificationControlSet] =
      useState<ClassificationControlSet>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      classificationControlSetsService
        .getById(id)
        .then((res) => {
          setClassificationControlSet(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateClassificationControlSetRequest) => {
      if (data) {
        setIsLoading(true)

        classificationControlSetsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="Sınıflandırma kontrol setleri"
          href="/classification-control-set"
        />
        <BreadcrumbItem text="Sınıflandırma kontrol seti güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli sınıflandırma kontrol
                  setini güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:{' '}
              {classificationControlSet ? classificationControlSet.text : null}
            </PageHeader>
            <ClassificationControlSetForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/classification-control-set">
                    İptal
                  </LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={classificationControlSet}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateClassificationControlSet
